"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IeModalStyled = void 0;

var _utils = require("../../../../utils");

var _modal = require("../../modal");

var _modalFooter = require("../../modal-footer");

var _modalBody = require("../../modal-body");

var _modalHeader = require("../../modal-header");

var _modalDialog = require("../../modal-dialog");

var _button = require("../../../button");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IeModalStyled = (0, _utils.styled)(_modal.Modal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", " {\n    max-width: 644px;\n    display: block;\n  }\n  ", " {\n    max-width: 644px;\n    display: block;\n  }\n  ", " {\n    max-width: 644px;\n    display: block;\n\n    ", " {\n      width: 52px;\n    }\n  }\n  ", " {\n    display: block;\n    max-width: 672px;\n  }\n"])), _modalFooter.ModalFooterStyled, _modalBody.ModalBodyStyled, _modalHeader.ModalHeaderStyled, _button.ButtonStyled, _modalDialog.Dialog);
exports.IeModalStyled = IeModalStyled;